import { lazy } from "react";
export const GraphsAsync = lazy(()=>import("./GraphsPage"))